import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DemandComments } from 'projects/Administration/src/app/business-entities/dwo-comments.model';
import { DwoDocumentsBusinessService } from 'projects/Administration/src/app/business-services/dwo-documents.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';

@Component({
  selector: 'app-mechanic-comments',
  templateUrl: './mechanic-comments.component.html',
})
export class MechanicCommentsComponent implements OnInit {
  response: DemandComments[];

  constructor(
    private service: DwoDocumentsBusinessService,
    private readonly editAppointmentService: EditAppointmentService,
    private spinner: NgxSpinnerService,
    private globalSetting: GlobalSetting
  ) {}

  ngOnInit(): void {
    let id;

    //Check for historical WO tab -> If true then appointmentGuid will be of selected WO.
    if (
      this.editAppointmentService.isFromHistoricalWOTab ||
      this.editAppointmentService.isFromVehicleHistoricalTab
    ) {
      id = this.editAppointmentService.appointmentIdOfSelectedWO;
    } else {
      id = this.editAppointmentService.appointmentDetails.id;
    }

    this.getMechanicComments(id);
  }

  getMechanicComments(id) {
    this.spinner.show();
    this.service.getDwoDemandComments(id).then((res) => {
      if (res.responseObject) {
        this.response = res.responseObject;
        if (this.response?.length !== undefined) {
          this.response.forEach(
            (x) => (x.updatedDate = new Date(x.updatedDate + 'Z'))
          );
        } else {
          this.response = [];
        }
      }
    });
    this.spinner.hide();
  }
}
